import React from "react";
import { FormHelper } from "utils/helpers";

function useFormDirtyCheck(initialValues: any, values: any, onFormDirtyChange?: (isDirty: boolean) => void) {
  const isDirty = React.useMemo(() => {
    const isFormDirty =
      initialValues && values
        ? FormHelper.isFormChanged(initialValues, values, [...Object.keys(initialValues), ...Object.keys(values)])
        : false;

    return isFormDirty;
  }, [initialValues, values]);

  React.useEffect(() => {
    if (onFormDirtyChange) {
      onFormDirtyChange(isDirty);
    }
  }, [isDirty]);

  return isDirty;
}

export default useFormDirtyCheck;
